// @flow
import React from 'react';
import { Label } from 'semantic-grab-ui/src';
import { statusLabel } from 'data/constants';
import _ from 'lodash';

const { colorMap } = statusLabel;

type Props = {
  status: string,
};

const StatusLabel = (props: Props) => {
  const status = _.upperCase(props.status);
  const color = _.get(colorMap, [status, 'color'], colorMap.default.color);
  const text = _.get(colorMap, [status, 'text'], status);

  return (
    <Label color={color}>{text}</Label>
  );
};

export default StatusLabel;
